import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-footer-cta',
  styleUrl: 'footer-cta.css',
  shadow: true,
})

export class CardCta {
  @Prop() textColor       : string = 'white';
  @Prop() backgroundColor : string = 'var(--cwc-footer-cta-bg, #0FC373)';
  @Prop() columns         : string;
  @Prop() fontSize        : string = '1.25rem';
  @Prop() gap             : string = null;
  @Prop() gapColumn       : string = this.gap ? this.gap : null;
  @Prop() gapRow          : string = this.gap ? this.gap : null;
  @Prop() maxWidth        : string = 'unset';
  @Prop() contentWidth    : string = '1350px';

  render() {
    return (
      <Host
        style={{
          backgroundColor: this.backgroundColor,
          color: this.textColor,
          maxWidth: this.maxWidth
        }}
      >
        <cradlepoint-container
          columns={this.columns}
          style={{
            fontSize: this.fontSize
          }}
          gap-column={this.gapColumn}
          gap-row={this.gapRow}
          maxWidth={this.contentWidth}
        >
          <slot></slot>
        </cradlepoint-container>
      </Host>
    );
  }

}
